// @ts-nocheck
// Ignore all typesript errors in this file. This file was originally created by the IBM Carbon team, but had to be modified to remove hardcoded IBM values
/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import cx from 'classnames';
import ButtonGroup from '@carbon/ibmdotcom-react/lib/components/ButtonGroup/ButtonGroup';
import Image from '@carbon/ibmdotcom-react/lib/components/Image/Image';
import settings from 'carbon-components/es/globals/js/settings';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import IPropsMSLeadSpaceBlockData from '..index';

var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;

/**
 * IBM Logo 8-bar component.
 */
const IbmLeadSpaceBlock = ({
  heading,
  copy,
  primaryCtaUrl,
  primaryCtaText,
  secondaryCtaUrl,
  secondaryCtaText,
  defaultImage,
  imageSm,
  imageMd,
  imageLg,
  imageXlg,
  imageMax,
  theme = 'dark',
  type = 'tall'
}: IPropsMSLeadSpaceBlockData) => {
  let primaryCta = null;
  let secondaryCta = null;

  if (primaryCtaUrl && primaryCtaText) {
    primaryCta = { href: primaryCtaUrl, copy: primaryCtaText };
  }
  if (secondaryCtaUrl && secondaryCtaText) {
    secondaryCta = { href: secondaryCtaUrl, copy: secondaryCtaText };
  }

  const buttons = [];
  if (primaryCta) buttons.push(primaryCta);
  if (secondaryCta) buttons.push(secondaryCta);

  const sources = [];
  if (imageSm) sources.push({ src: imageSm, breakpoint: 'sm' });
  if (imageMd) sources.push({ src: imageMd, breakpoint: 'md' });
  if (imageLg) sources.push({ src: imageLg, breakpoint: 'lg' });
  if (imageXlg) sources.push({ src: imageXlg, breakpoint: 'xlg' });
  if (imageMax) sources.push({ src: imageMax, breakpoint: 'max' });

  return (
    <div
      data-autoid={`${stablePrefix}--leadspace`}
      className={`${prefix}--leadspace ${prefix}--leadspace--${
        type === 'centered' ? 'tall' : type
      }`}
    >
      <section
        className={`${prefix}--leadspace__section ${
          theme === 'light'
            ? `${prefix}--leadspace--white`
            : `${prefix}--leadspace--g90`
        } ${type === 'centered' ? `${prefix}--leadspace--centered` : ''}`}
      >
        <div className={`${prefix}--leadspace__container`}>
          <div
            className={`${prefix}--leadspace__overlay ${prefix}--leadspace--gradient`}
          >
            <svg
              className={`${prefix}--leadspace__gradient`}
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <linearGradient
                  id="stops"
                  className={`${prefix}--leadspace__gradient__stops`}
                  gradientTransform=""
                >
                  <stop offset="0%"></stop>
                  <stop offset="25%"></stop>
                  <stop offset="50%"></stop>
                  <stop offset="75%"></stop>
                </linearGradient>
              </defs>
              <rect
                className={`${prefix}--leadspace__gradient__rect`}
                width="100"
                height="100"
              ></rect>
            </svg>
            <div
              className={`${prefix}--leadspace--content__container bx--grid`}
            >
              <div className={`${prefix}--leadspace__row`}>
                <h1 className={`${prefix}--leadspace__title`}>{heading}</h1>
              </div>
              <div className={`${prefix}--leadspace__content`}>
                <div className={`${prefix}--leadspace__row`}>
                  <p
                    data-autoid={`${stablePrefix}--leadspace__desc`}
                    className={`${prefix}--leadspace__desc ${
                      buttons.length > 0
                        ? ''
                        : `${prefix}--leadspace--desc-no-btns`
                    }`}
                  >
                    {copy}
                  </p>
                </div>
                {buttons.length > 0 && <ButtonGroup buttons={buttons} />}
              </div>
            </div>
          </div>
          <Image
            defaultSrc={defaultImage}
            alt="Image alt text"
            sources={sources}
          />
        </div>
      </section>
    </div>
  );
};

export default IbmLeadSpaceBlock;
